export const appRouter = {
  // GTILogin: "/gti-portal/login",
  // Corporates: "/gti-portal/corporates",
  // CorporateMembers: "/gti-portal/corporates/members",
  // Dashboard: "/gti-portal/dashboard",
  // Settings: "/gti-portal/settings",

  DMQLogin: "/login",
  FormFilling: "/form-filling",
  SubmissionComplete: "/submission-complete",
  LinkExpired: "/link-expired",
  AppDisclaimer: "/app-disclaimer",
  MaintenanceMode: "/app-maintenance",
};
